import { motion } from "framer-motion";
import Fixed from "./Fixed";
import Footer1 from "./Footer1";
import A1img from "../Assets/A1.webp";
import A2img from "../Assets/A2.jpg";
import { Link } from "react-router-dom";

export default function AboutUs() {
  return (
    <div>
      <Fixed />
      <div className="text-gray-900 pt-20">
        {/* Hero Section */}
        <section className="relative h-[80vh] flex items-center justify-center">
          <motion.div 
            initial={{ opacity: 0, y: 50 }} 
            animate={{ opacity: 1, y: 0 }} 
            transition={{ duration: 0.8 }}
            className="relative z-10 text-center px-8"
          >
            <h1 className="text-6xl font-extrabold leading-tight text-gray-800">Empowering the Future with Smart Solutions</h1>
            <p className="mt-6 text-xl font-light max-w-2xl mx-auto text-gray-700">Innovative Intelligence for Modern Businesses</p>
          </motion.div>
        </section>
        
        {/* Services Section */}
        <section className="py-20 px-6 max-w-7xl mx-auto bg-gray-100">
          <div className="grid md:grid-cols-2 gap-12 items-center">
            <div>
              <img src={A1img} alt="Smart Solutions" className="rounded-lg shadow-md" />
            </div>
            <div>
              <p className="text-lg text-gray-700 leading-relaxed">
                We specialize in providing cutting-edge smart systems that revolutionize the way businesses operate. From automated processes to IoT-based solutions, we bring innovation to life, helping businesses enhance efficiency, security, and productivity.
              </p>
            </div>
          </div>
          <div className="grid md:grid-cols-2 gap-12 items-center mt-12">
            <div className="order-2 md:order-1">
              <p className="text-lg text-gray-700 leading-relaxed">
              Our value-added services include network services and call center empowerment. We also offer JCSPay, a secure payment gateway designed to simplify transactions for businesses and individuals alike.

              </p>
            </div>
            <div className="order-1 md:order-2">
              <img src={A2img} alt="Secure Payment Solutions" className="rounded-lg shadow-md" />
            </div>
          </div>
        </section>

        {/* Mission & Vision */}
        <section className="py-24 px-8 text-center bg-blue-600">
          <h2 className="text-4xl font-bold text-white">Our Mission & Vision</h2>
          <p className="mt-6 max-w-4xl mx-auto text-lg font-light text-white">We are committed to delivering smart and innovative solutions that enhance businesses and improve everyday life.</p>
        </section>

        {/* Contact Section */}
        <section className="py-24 px-8 max-w-6xl mx-auto text-center bg-gray-50">
          <h2 className="text-4xl font-bold text-gray-900 mb-8">Get in Touch</h2>
          <p className="text-lg max-w-3xl mx-auto text-gray-700 mb-8">For partnerships, inquiries, or support, reach out to us via email or phone.</p> {/* Added margin-bottom */}
          <Link 
            to="/contact-us"
            className="mt-8 px-8 py-4 bg-blue-600 text-white text-lg font-semibold rounded-full shadow-md hover:scale-105 transition-transform duration-300"
          >
            Contact Us
          </Link>
        </section>
      </div>
      <Footer1 />
    </div>
  );
}
